import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gtf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n, currency = "INR") => {
  const v = Number(n || 0);
  const sym = { INR: "₹", USD: "$", GBP: "£", AED: "AED ", SGD: "S$", AUD: "A$", EUR: "€", JPY: "¥" }[currency] || "";
  if (v >= 10000000) return `${sym}${(v / 10000000).toFixed(2)}Cr`;
  if (v >= 100000) return `${sym}${(v / 100000).toFixed(2)}L`;
  if (v >= 1000) return `${sym}${(v / 1000).toFixed(1)}k`;
  return `${sym}${v.toLocaleString()}`;
};

export const num = (n) => Number(n || 0).toLocaleString();

export default api;
